import onboardingBlocksJSON from '../../onboarding.json';
import api from '@/lib/api.js';

export default {
	async insertOnboardingBlocks(store) {
		let rootBlock = store.getters.rootBlock;
		let blocks = [];
		let blocksArray = rootBlock.blocks;
		let currentBlocks = store.state.blocks;
		let user = store.rootGetters['user/user'];
		for (let i = 0; i < onboardingBlocksJSON.blocks.length; i++) {
			blocksArray.push(onboardingBlocksJSON.blocks[i]._id);
			onboardingBlocksJSON.blocks[i].owner = user._id;
			onboardingBlocksJSON.blocks[i].parent = rootBlock._id;
			blocks.push(onboardingBlocksJSON.blocks[i]);
		}

		rootBlock.blocks = blocksArray;
		blocks = currentBlocks.concat(blocks);

		console.log(rootBlock);

		await store.dispatch('bulkAddBlocks', blocks);
		await store.dispatch('updateBlock', rootBlock);
		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/bulkAddBlocks',
					payload: blocks
				},
				{
					name: 'block/updateBlock',
					payload: rootBlock
				}
			],
			{ root: true }
		);
		return true;
	},

	async convertNotes(store, notes) {
		let rootBlock = store.getters.rootBlock;
		let blocks = [];
		let blocksArray = rootBlock.blocks;
		let currentBlocks = store.state.blocks;
		let user = store.rootGetters['user/user'];
		let newNotes = _.groupBy(notes, 'domain');

		let newFolderBlocks = [];

		let tempBlock = {
			_id: nanoid(),
			owner: user._id,
			parent: rootBlock._id,
			type: 'text',
			blocks: [],
			content: {
				html: `# We've imported ${notes.length} notes from your previous account.`
			},
			source: {},
			createdAt: new Date(),
			updatedAt: new Date(),
			root: false,
			archive: false
		};
		blocksArray.push(tempBlock._id);
		blocks.push(tempBlock);
		tempBlock = {
			_id: nanoid(),
			owner: user._id,
			parent: rootBlock._id,
			type: 'text',
			blocks: [],
			content: {
				html: `# They are arranged inside folder blocks grouped by domain name`
			},
			source: {},
			createdAt: new Date(),
			updatedAt: new Date(),
			root: false,
			archive: false
		};
		blocksArray.push(tempBlock._id);
		blocks.push(tempBlock);

		for (const property in newNotes) {
			let block = {
				_id: nanoid(),
				owner: user._id,
				parent: rootBlock._id,
				type: 'folder',
				blocks: [],
				content: {
					title: property
				},
				source: {},
				createdAt: new Date(),
				updatedAt: new Date(),
				root: false,
				archive: false
			};
			blocksArray.push(block._id);
			blocks.push(block);
			newFolderBlocks.push(block);
		}

		blocks = currentBlocks.concat(blocks);
		rootBlock.blocks = blocksArray;
		let newBlocks = await api.blocks.addBlocks(blocks);
		await api.blocks.updateBlock(rootBlock);
		store.commit('UPDATE_BLOCK', rootBlock);
		store.commit('SET_BLOCKS', blocks);

		for (const property in newNotes) {
			let parent = null;
			blocks = [];
			for (let i = 0; i < newFolderBlocks.length; i++) {
				if (newFolderBlocks[i].content.title === property) {
					parent = newFolderBlocks[i];
					break;
				}
			}

			if (parent) {
				for (let i = 0; i < newNotes[property].length; i++) {
					let block = {
						_id: newNotes[property][i]._id,
						owner: user._id,
						parent: parent._id,
						type: 'text',
						blocks: [],
						content: {
							html: newNotes[property][i].text || ''
						},
						source: {},
						createdAt: newNotes[property][i].createdAt || new Date(),
						updatedAt: newNotes[property][i].updatedAt || new Date(),
						root: false,
						archive: false
					};
					parent.blocks.push(block._id);
					blocks.push(block);
				}
				await api.blocks.updateBlock(parent);
				await api.blocks.addBlocks(blocks);

				store.commit('UPDATE_BLOCK', parent);
			}
		}

		blocks = await api.blocks.getBlocks();
		store.commit('SET_BLOCKS', blocks);

		return blocks;
	},

	// Converts notes(from underlineme v1) to blocks
	async notesToBlocks(store) {
		let response = await api.notes.getNotes();
		if (response && response.data) {
			let blocks = await store.dispatch('convertNotes', response.data);
		}
		return true;
	}
};
